/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(theme => ({
  tableContainer: {
    minHeight: 0,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    '& tr[borderposition="top"] td': {
      borderTop: `1px solid ${theme.palette.grey[300]} !important`
    }
  },
  chip: {
    margin: theme.spacing(-0.5, 0, 0, 0.5),
    background: 'white'
  },
  actionIcon: {
    marginRight: Tokens.spacing['$sp-1'],
    alignSelf: 'center',
  },
  list: {
    padding: `${theme.spacing(0, 0, 1.75)} !important`
  },
  listItem: {
    padding: `${theme.spacing(0, 2, 0, 3.75)} !important`
  },
  alertMsg: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: Tokens.spacing['$sp-3-5']
  },
  warningIcon: {
    marginRight: 10,
  },
}));
